import BaseTemplate from './baseTemplate'
import Role from '@/models/role'

export default class RoleTemplate extends BaseTemplate<Role> {
  public toChange: boolean = false
  public toDelete: boolean = false

  public get id(): number {
    return this.item.id
  }
  public get name(): string {
    return this.item.name
  }
  public get appPermissions(): number[] {
    return this.item.permissions
  }
  public get schoolId(): number | null {
    return this.item.school_id
  }

  constructor(role: Role) {
    super(role)
  }
  public setAppPermissions(appPermission: number) {
    const index: number = this.item.permissions.indexOf(appPermission)
    index >= 0
      ? this.item.permissions.splice(index, 1)
      : this.item.permissions.push(appPermission)
    this.toChange = true
  }
}
